import { UserManager } from 'oidc-client-ts';
import { useEffect } from 'react';

const oidcConfig = {
  client_id: 'access.erp.creditcontrol.dev',
  redirect_uri: window.location.origin,
  silent_redirect_uri: `${window.location.origin}/login/callback`,
  scope: 'openid profile email policy access.erp.creditcontrol',
};

export default function LoginCallback() {
  useEffect(() => {
    const handleCallback = async () => {
      try {
        const userManager = new UserManager({
          ...oidcConfig,
          authority: '',
        });

        await userManager.signinCallback();
      } catch (error) {
        console.error('Error during silent callback processing:', error);
      }
    };

    handleCallback();
  }, []);

  return null;
}
